import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '@client';

export const qaAdminSupportApi = createApi({
  baseQuery: axiosBaseQuery(),
  reducerPath: 'qaAdminSupport_api',
  endpoints: (build) => ({
    setupDemoCompany: build.mutation<
      void,
      { firstName: string; lastName: string }
    >({
      query: ({ firstName, lastName }) => ({
        url: `/secured/qa-task/setup-demo-company`,
        method: 'POST',
        data: { firstName, lastName }
      })
    }),
    cloneDaFromAnotherCompany: build.mutation<
      number,
      { proformaId: number; targetCompanyId: number }
    >({
      query: ({ proformaId, targetCompanyId }) => ({
        url: `/secured/qa-task/cloneDa`,
        method: 'POST',
        data: { proformaId, targetCompanyId }
      })
    })
  })
});

export type StateWithQaAdminSupportApi = {
  [qaAdminSupportApi.reducerPath]: ReturnType<typeof qaAdminSupportApi.reducer>;
};

export const {
  useSetupDemoCompanyMutation,
  useCloneDaFromAnotherCompanyMutation
} = qaAdminSupportApi;
